// Fungsi matematika dasar: FPB, KPK, penyederhanaan pecahan.
import { R } from './random.js';

export const gcd=(a,b)=>{a=Math.abs(a);b=Math.abs(b);while(b){[a,b]=[b,a%b];}return a;};
export const lcm=(a,b)=>a/gcd(a,b)*b;
export const lcmAll=arr=>arr.reduce((x,y)=>lcm(x,y),1);
export const r3=x=>Math.round(x*1000)/1000;
export const simp=(n,d)=>{const g=gcd(n,d)||1;return [n/g,d/g];};
export const coprime=d=>{let n;do{n=R(1,d-1);}while(gcd(n,d)!==1);return n;};
export const divisors=n=>{const r=[];for(let i=1;i<=n;i++)if(n%i===0)r.push(i);return r;};
